import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
    ViewChild,
    ElementRef
} from '@angular/core';
import { IdName } from '../domain/idname';
import { Totaling } from '../domain/totaling';
import { LookupService } from '../service/lookup.service';
import { IdNameReportType } from '../domain/idnamereporttype';
import { FormulaElement } from '../domain/formulaElement';

@Component({
    selector: 'app-formula-picker',
    templateUrl: './formula-picker.component.html',
    styles: [
        `
            :host ::ng-deep .priority-2,
            :host ::ng-deep .priority-3,
            :host ::ng-deep .visibility-sm {
                display: none;
            }

            @media screen and (max-width: 39.938em) {
                :host ::ng-deep .visibility-sm {
                    display: inline;
                }
            }

            @media screen and (min-width: 40em) {
                :host ::ng-deep .priority-2 {
                    display: table-cell;
                }
            }

            @media screen and (min-width: 64em) {
                :host ::ng-deep .priority-3 {
                    display: table-cell;
                }
            }
        `
    ]
})
export class FormulaPickerComponent implements OnInit {
    constructor(private lookupService: LookupService) {}

    @Input() reportId: string;
    @Input() lineId: string;
    @Input() formulaElement: FormulaElement[];
    @Output() formulaElementChange = new EventEmitter();

    @Input() report: IdName;
    @Output() reportChange = new EventEmitter();

    @Input() name: string;
    @Input() label: string;

    formulaPickerVisible = false;

    formula: Array<IdName>;

    selectedFormula: Array<IdName>;

    reports: IdNameReportType[];

    tableColumns: any[];

    ngOnInit() {
        this.tableColumns = [{ field: 'codeName', header: 'Name', length: '100%' }];

        if (this.reportId !== 'new') {
            this.lookupService
                .getIdNameReportType(`formula-reports/${this.reportId}`)
                .then(objects => {
                    this.reports = objects;
                });
        }
    }
    changeReport(newValue) {
        this.report = newValue;
        this.reportChange.emit(newValue);
    }

    changeFormulaElement(newValue) {
        this.formulaElement = newValue;
        this.formulaElementChange.emit(newValue);
    }

    onFormulaPicker() {
        this.lookupService.getLinesForReport(this.report.id).then(objects => {
            this.selectedFormula = [];
            this.formula = objects;

            this.formula.forEach(f => {
                f.codeName = f.name + " " + f.desc;
            });

            // this.lookupService.setAllReportFormulasPickersIds(this.formulaElement);
            // this.lookupService.allReportFormulasPickersIds.forEach(id => {
            //     this.formula.splice(this.formula.findIndex(f => f.id === id), 1);
            // })

            this.formulaElement.forEach(selected => {
                this.formula.splice(this.formula.findIndex(f => f.id == selected.IdLine), 1);
            });
            this.formulaPickerVisible = true;
        });
    }

    okClickFormula() {
        this.selectedFormula.forEach(element => {
            const chip = new FormulaElement();
            chip.IdLine = element.id;
            chip.RowNo = element.name;
            chip.Sign = '+';
            chip.Description = element.desc;

            if (!this.formulaElement) {
                this.formulaElement = new Array<FormulaElement>();
            }
            this.formulaElement.push(chip);
        });

        this.formulaPickerVisible = false;

        this.changeFormulaElement(this.formulaElement);
    }

    onChipRemove()
    {
        this.changeFormulaElement(this.formulaElement);
    }
    removeAccounts(id) {
        this.formulaElement= this.formulaElement.filter((chip) => {
            return chip.IdLine !== id;
        });
        this.changeFormulaElement(this.formulaElement);
    }

    dropDownOnChange(event) {
        this.changeReport(event.value);
    }
}
